import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { DirectivesModule } from "../directives/directives.module";
import { CustomerCreateModalComponent } from "../modals/customer-create-modal/customer-create-modal.component";
import { PipesModule } from "../pipes/pipes.module";
import { BulkCustomerCreateComponent } from "./bulk-customer-create/bulk-customer-create.component";
import { CalendarGroupListComponent } from "./calendar-group-list/calendar-group-list.component";
import { CalendarComponent } from "./calendar/calendar.component";
import { CustomerInviteComponent } from "./customer-invite/customer-invite.component";
import { CustomerIonItemComponent } from "./customer-ion-item/customer-ion-item.component";
import { CustomerSearchListComponent } from "./customer-search-list/customer-search-list.component";
import { CustomersCellRendererComponent } from "./customers-cell-renderer.component";
import { EmployeeInviteComponent } from "./employee-invite/employee-invite.component";
import { EmployeeIonItemComponent } from "./employee-ion-item/employee-ion-item.component";
import { ExerciseContainerComponent } from "./exercise-container/exercise-container.component";
import { ExerciseFieldFilterComponent } from "./exercise-field-filter/exercise-field-filter.component";
import { GoogleSignInButtonComponent } from "./google-sign-in-button/google-sign-in-button.component";
import { GroupCriteriaComponent } from "./group-criteria/group-criteria.component";
import { InlineSearchComponent } from "./inline-search/inline-search.component";
import { LoggedWorkoutItemComponent } from "./logged-workout-item/logged-workout-item.component";
import { LogoComponent } from "./logo/logo.component";
import { NotificationsBadgeComponent } from "./notifications-badge/notifications-badge.component";
import { NotificationsPopoverComponent } from "./notifications-popover/notifications-popover.component";
import { OnboardingProgressMenuItemComponent } from "./onboarding-progress-menu-item/onboarding-progress-menu-item.component";
import { ProfileImageComponent } from "./profile-image/profile-image.component";
import { ProfileImagesContainerComponent } from "./profile-images-container/profile-images-container.component";
import { SvgProgressComponent } from "./svg-progress/svg-progress.component";
import { VideoUploadComponent } from "./video-upload/video-upload.component";
import { WorkoutCopyTimelineIllustrationComponent } from "./workout-copy-timeline-illustration/workout-copy-timeline-illustration.component";
import { WorkoutIonItemComponent } from "./workout-ion-item/workout-ion-item.component";
import { WorkoutStepsListComponent } from "./workout-steps-list/workout-steps-list.component";
import { TagBadgeComponent } from "./tag-badge/tag-badge.component";
import { TagSelectComponent } from "./tag-select/tag-select.component";
import { FolderSelectComponent } from "./folder-select/folder-select.component";
import { CustomFieldComponent } from "./custom-field/custom-field.component";
import { WorkoutStepComponent } from "./workout-steps-list/workout-step/workout-step.component";
import { BillingBannerComponent } from "./billing-banner/billing-banner.component";
import { BillingMenuInfoComponent } from "./billing-menu-info/billing-menu-info.component";
import { BillingInfoComponent } from "./billing-info/billing-info.component";
import { WorkoutHeaderComponent } from "./workout-header/workout-header.component";
import { UnitOfMeasureComponent } from "./unit-of-measure/unit-of-measure.component";
import { LogWorkoutFormComponent } from "./log-workout-form/log-workout-form.component";
import { LoggedWorkoutStepsListComponent } from "./logged-workout-steps-list/logged-workout-steps-list.component";
import { NgxIntlModule } from "../ngx-intl/ngx-intl.module";
import { EntityDisplayedDateComponent } from "./entity-displayed-date/entity-displayed-date.component";
import { ExerciseVideoComponent } from "./exercise-video/exercise-video.component";
import { TagFilterButtonComponent } from "./tag-filter-button/tag-filter-button.component";
import { TagSelectColorPickerComponent } from "./tag-select-color-picker/tag-select-color-picker.component";
import { BannerComponent } from "./banner/banner.component";
import { IsNewBadgeComponent } from "./is-new-badge/is-new-badge.component";
import { ValueEditorComponent } from "./value-editor/value-editor.component";
import { TimeInputCellComponent } from "./time-input-cell/time-input-cell.component";
import { TabularDataComponent } from "./tabular-data/tabular-data.component";
import { EntityFilterButtonComponent } from "./entity-filter-button/entity-filter-button.component";
import { FormsSubmitterComponent } from "./forms-submitter/forms-submitter.component";
import { FormDetailsCardComponent } from "./form-details-card/form-details-card.component";
import { FormSubmissionListComponent } from "./form-submission-list/form-submission-list.component";
import { FormSubmissionDetailsCardComponent } from "./form-submission-details-card/form-submission-details-card.component";
import { CopilotPaneComponent } from "./copilot-pane/copilot-pane.component";
import { CopilotPaneOpenButtonComponent } from "./copilot-pane-open-button/copilot-pane-open-button.component";
import { VersionTagComponent } from "./version-tag/version-tag.component";
import { QuickcoachImportToolComponent } from "./quickcoach-import-tool/quickcoach-import-tool.component";
import { FolderContentsListComponent } from './folder-contents-list/folder-contents-list.component';
import { SortPopoverComponent } from './sort-popover/sort-popover.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { OnboardingFeaturesListComponent } from './onboarding-features-list/onboarding-features-list.component';
import { CurrentUserItemComponent } from './current-user-item/current-user-item.component';
import { ClickableBodyMapComponent } from './clickable-body-map/clickable-body-map.component';
import { TagManageModalComponent } from '../modals/tag-manage-modal/tag-manage-modal.component';
import { TagOverviewComponent } from './tag-overview/tag-overview.component';
import { CustomerMedicalConditionUpsertComponent } from './customer-medical-condition-upsert/customer-medical-condition-upsert.component';
import { CustomerMedicalTreatmentUpsertComponent } from './customer-medical-treatment-upsert/customer-medical-treatment-upsert.component';
import { MedicalStatusButtonComponent } from './medical-status-button/medical-status-button.component';

@NgModule({
  imports: [
    IonicModule,
    TranslateModule.forChild(),
    CommonModule,
    PipesModule,
    FormsModule,
    ReactiveFormsModule,
    DirectivesModule,
    RouterModule,
    NgxIntlModule,
    ScrollingModule
  ],
  exports: [
    BulkCustomerCreateComponent,
    QuickcoachImportToolComponent,
    CalendarComponent,
    ProfileImageComponent,
    ProfileImagesContainerComponent,
    LogoComponent,
    ExerciseContainerComponent,
    CustomerInviteComponent,
    GoogleSignInButtonComponent,
    EmployeeInviteComponent,
    ExerciseFieldFilterComponent,
    CustomersCellRendererComponent,
    NotificationsBadgeComponent,
    NotificationsPopoverComponent,
    WorkoutStepsListComponent,
    CustomerSearchListComponent,
    InlineSearchComponent,
    CalendarGroupListComponent,
    CustomerIonItemComponent,
    EmployeeIonItemComponent,
    WorkoutIonItemComponent,
    LoggedWorkoutItemComponent,
    WorkoutCopyTimelineIllustrationComponent,
    TagSelectComponent,
    FolderSelectComponent,
    TagBadgeComponent,
    VideoUploadComponent,
    GroupCriteriaComponent,
    SvgProgressComponent,
    OnboardingProgressMenuItemComponent,
    CustomerCreateModalComponent,
    CustomFieldComponent,
    WorkoutHeaderComponent,
    UnitOfMeasureComponent,
    WorkoutStepComponent,
    LogWorkoutFormComponent,
    LoggedWorkoutStepsListComponent,
    EntityDisplayedDateComponent,
    ExerciseVideoComponent,
    TagFilterButtonComponent,
    TagSelectColorPickerComponent,
    BannerComponent,
    IsNewBadgeComponent,
    ValueEditorComponent,
    TimeInputCellComponent,
    TimeInputCellComponent,
    TabularDataComponent,
    EntityFilterButtonComponent,
    FormsSubmitterComponent,
    FormDetailsCardComponent,
    FormSubmissionListComponent,
    FormSubmissionDetailsCardComponent,
    CopilotPaneComponent,
    CopilotPaneOpenButtonComponent,
    VersionTagComponent,
    FolderContentsListComponent,
    SortPopoverComponent,
    BillingBannerComponent,
    BillingMenuInfoComponent,
    BillingInfoComponent,
    OnboardingFeaturesListComponent,
    CurrentUserItemComponent,
    ClickableBodyMapComponent,
    TagManageModalComponent,
    TagOverviewComponent,
    CustomerMedicalConditionUpsertComponent,
    CustomerMedicalTreatmentUpsertComponent,
    MedicalStatusButtonComponent
  ],
  declarations: [
    BulkCustomerCreateComponent,
    QuickcoachImportToolComponent,
    CalendarComponent,
    ProfileImageComponent,
    ProfileImagesContainerComponent,
    LogoComponent,
    ExerciseContainerComponent,
    CustomerInviteComponent,
    GoogleSignInButtonComponent,
    EmployeeInviteComponent,
    ExerciseFieldFilterComponent,
    CustomersCellRendererComponent,
    NotificationsBadgeComponent,
    NotificationsPopoverComponent,
    WorkoutStepsListComponent,
    CustomerSearchListComponent,
    InlineSearchComponent,
    CalendarGroupListComponent,
    CustomerIonItemComponent,
    EmployeeIonItemComponent,
    WorkoutIonItemComponent,
    LoggedWorkoutItemComponent,
    WorkoutCopyTimelineIllustrationComponent,
    TagSelectComponent,
    FolderSelectComponent,
    TagBadgeComponent,
    VideoUploadComponent,
    GroupCriteriaComponent,
    SvgProgressComponent,
    OnboardingProgressMenuItemComponent,
    CustomerCreateModalComponent,
    CustomFieldComponent,
    WorkoutStepComponent,
    WorkoutHeaderComponent,
    UnitOfMeasureComponent,
    LogWorkoutFormComponent,
    LoggedWorkoutStepsListComponent,
    EntityDisplayedDateComponent,
    ExerciseVideoComponent,
    TagFilterButtonComponent,
    TagSelectColorPickerComponent,
    BannerComponent,
    IsNewBadgeComponent,
    ValueEditorComponent,
    TimeInputCellComponent,
    TabularDataComponent,
    EntityFilterButtonComponent,
    FormsSubmitterComponent,
    FormDetailsCardComponent,
    FormSubmissionListComponent,
    FormSubmissionDetailsCardComponent,
    CopilotPaneComponent,
    CopilotPaneOpenButtonComponent,
    VersionTagComponent,
    FolderContentsListComponent,
    SortPopoverComponent,
    BillingBannerComponent,
    BillingMenuInfoComponent,
    BillingInfoComponent,
    OnboardingFeaturesListComponent,
    CurrentUserItemComponent,
    ClickableBodyMapComponent,
    TagManageModalComponent,
    TagOverviewComponent,
    CustomerMedicalConditionUpsertComponent,
    CustomerMedicalTreatmentUpsertComponent,
    MedicalStatusButtonComponent
  ],
})
export class ComponentsModule { }
